import { ExternalLink, WrapperEntitySelector } from '@components/Inputs';
import { GridContainerFullHeight, TextInput, Typography } from '@ts/storybook';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { IForm } from '@ts/ui-models';

interface IOrganizationFormProps extends IForm {
  values: any; //TODO: COrganization add props in ui-models
}

const OrganizationForm = (props: IOrganizationFormProps) => {
  const { values, mode, onCallbackChange, requiredFields } = props;
  const isViewMode = mode === 'view';

  return (
    <GridContainerFullHeight>
      <Typography variant="h6" text="Organization information" />
      <TextInput
        label={'Name'}
        value={values.name}
        onChangeValue={onCallbackChange('name')}
        required={requiredFields.includes('name')}
        isReadOnly={isViewMode}
      />
      <WrapperEntitySelector
        label={'Identity provider'}
        searchComponent={generateSearchEntitySelector('identityProvider')}
        value={values.identityProvider ?? values.identityProviderId}
        onChangeEntity={(entity: any) => {
          onCallbackChange('identityProvider')(entity);
          onCallbackChange('identityProviderId')(entity?.getID());
        }}
        isReadOnly={isViewMode}
      />
      <TextInput label="Tenant ID" value={values.tenantId} onChangeValue={onCallbackChange('tenantId')} isReadOnly={isViewMode} />
      <ExternalLink
        onChangeLink={onCallbackChange('externalHttpLink')}
        onChangeCaption={onCallbackChange('externalHttpLinkCaption')}
        url={values.externalHttpLink}
        caption={values.externalHttpLinkCaption}
        fDisabled={isViewMode}
        viewFields={mode === 'edit' || mode === 'new'}
        inLine
      />
      <TextInput
        label={'Notes'}
        value={values.notes}
        onChangeValue={onCallbackChange('notes')}
        isReadOnly={isViewMode}
        multiline
      />
    </GridContainerFullHeight>
  );
};

export default OrganizationForm;
